import { Component, Input, ViewChild } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { ProjectTreeModalService } from './project.tree.modal.service';
import customerJson from "../../../../assets/config/customer.json";
import translateJson from '../../../../translate.json';
import { AppService } from '../../../app.service';

/**
 * Project data with nested structure.
 * Each node has a name and an optiona list of children.
 */
 interface ProjectNode {  
    id: string;
    organisationId: string;  
    name: string,
    compProjectId: string,
    compProjectName: string,
    compIndustry: string,
    supplierType: string,
    archived: boolean,
    children?: ProjectNode[];
  }

  const PROJECT_DATA: ProjectNode[] = [];
  
   interface ProjectFlatNode {
    expandable: boolean;
    name: string;
    id: string;   
    supplierType: string; 
    compProjectId: string;
    archived: boolean;
    level: number;
  }

@Component({
    selector: 'project-tree-modal',
    providers: [NgxSmartModalService, ProjectTreeModalService, AppService],
    templateUrl: './project.tree.modal.component.html',
    styleUrls: ['./project.tree.modal.component.css']
})
export class ProjectTreeModalComponent {   
    @ViewChild('tree') tree;  
    @Input() currentProject: any;
    private i18 = translateJson.i18;
    private supplier: any;
    private errorMessage: any[];
    edition: String = customerJson.edition;
    private errors: any[] = [];
    private showErrorMsgBool: boolean = false;

    private _transformer = (node: ProjectNode, level: number) => {
        return {
          expandable: !!node.children && node.children.length > 0,
          name: node.name,      
          supplierType: node.supplierType,  
          compProjectId: node.compProjectId,
          archived: node.archived,  
          level: level,
        };
      };

    treeControl = new FlatTreeControl<ProjectFlatNode>(
        (node) => node.level,
        (node) => node.expandable
    );

    treeFlattener = new MatTreeFlattener(
        this._transformer,
        (node) => node.level,
        (node) => node.expandable,
        (node) => node.children
    );

    dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    constructor(private ngxSmartModalService: NgxSmartModalService, private service: ProjectTreeModalService,
    private appService: AppService) {}

    hasChild = (_: number, node: ProjectFlatNode) => node.expandable;      

    private async handleCurrentProjectChange(project: any) {
        let projectName = this.sanitizeProjectName(project.compProjectName);
        this.supplier = await this.getHeadSupplierByProjectName(projectName);

        if(this.supplier.length > 0) {
            this.dataSource.data = this.supplier;      
            this.tree.treeControl.expandAll();  
        } else {
            this.setError(projectName);
        }        
    }

    private async getHeadSupplierByProjectName(projectName: string) {
        try {
            if(this.edition === 'company') {                
                const result = await this.service.getCustomerSupplierByProjectName(projectName).toPromise();               
                return result;
            } else if (this.edition === 'government') {
                const result = await this.service.getHeadSupplierByProjectName(projectName).toPromise();                
                return result;
            }
        } catch (error) {
            this.setError(projectName);            
        }
        return null;
    }

    setError(projectName) {
        this.errors.push(this.i18.hierarchy.modal.hierarchyErrorMsgPartOne + projectName + this.i18.hierarchy.modal.hierarchyErrorMsgPartTwo);
        this.errorMessage = this.errors;
        this.showErrorMsgBool = true;
    }

    /* MODAL FUNCTIONS */
    pop() {
        this.ngxSmartModalService.getModal('projectTreeModal').open();
        this.handleCurrentProjectChange(this.currentProject);
    }

    close() {
        this.ngxSmartModalService.getModal('projectTreeModal').close();
    }

    setRoute(projectId){
        this.appService.setRoute('/project/view/' + projectId);
    }

    sanitizeProjectName(projectName){
        let result = projectName.replace('/', '%2F');
        result = result.replace('\\', '%5C');
        return result;
    }

    deSanitizeProjectName(projectName){
        let result = projectName.replace('%2F', '/');
        result = result.replace('%5C', '\\');
        return result;
    }
    
}